/**
 * @param {Array} users
 * @param {string=} orderField
 * @param {string=} orderDirection
 * @param {function} onOrder
 * @param {boolean} rowsDisabled
 * @param {function} onDelete
 * @param {function} onAutoLogin
 * @param {function} onRefreshIntercomTags
 * @param {function} onShowEditModal
 */
import React from "react";
import SortableTh from "../../theme/untitled/SortableTh/SortableTh";
import TableRow from "./TableRow";
import styles from "./UsersPage.module.scss";

const COLUMNS = [
  { key: "name", label: "Name", orderField: "name" },
  { key: "email", label: "Email", orderField: "email", className: styles.colEmail },
  { key: "verified", label: "Verified", className: styles.colVerified },
  { key: "join_date", label: "Join date", orderField: "join_date", className: styles.colJoin },
  { key: "last_login", label: "Last login", orderField: "last_login", className: styles.colLastLogin },
];

const UsersTable = ({
  users,
  orderField,
  orderDirection,
  onOrder,
  rowsDisabled,
  onDelete,
  onAutoLogin,
  onRefreshIntercomTags,
  onShowEditModal,
}) => {
  const cols = COLUMNS.slice(1).map((col) => <col key={col.key} className={col.className} />);

  const headerCells = COLUMNS.map((col) => (
    <SortableTh
      key={col.key}
      orderField={col.orderField}
      currentDirection={orderField === col.orderField ? orderDirection : null}
      onOrder={onOrder}
    >
      {col.label}
    </SortableTh>
  ));

  const rows = users.map((user) => (
    <TableRow
      key={user.uuid}
      user={user}
      disabled={rowsDisabled}
      onDelete={onDelete}
      onAutoLogin={onAutoLogin}
      onRefreshIntercomTags={onRefreshIntercomTags}
      onShowEditModal={onShowEditModal}
    />
  ));

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <colgroup>
          <col />
          {cols}
          <col className={styles.colActions} />
        </colgroup>
        <thead>
          <tr>
            {headerCells}
            <th scope="col" aria-hidden="true" />
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default UsersTable;
